// extracted by mini-css-extract-plugin
export var teamContainer = "people-module--team-container--AU-3W";